import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class ImageService {
    constructor() { }

    public getPdfAsImage(base64: string): string {
        const blob = this.b64toBlob(base64);
        return window.URL.createObjectURL(blob);
    }

    public getFile(base64: string, type: string = 'image/png'): void {
        const blob = this.b64toBlob(base64);
        const newBlob = new Blob([blob], { type: 'image/png' });
        this.saveData(newBlob);
    }

    public getBase64ImageUri(value: string): string {
        value.replace('application/pdf', 'image/png');
        return value;
    }

    private b64toBlob = (b64Data: string, contentType = '', sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    public blobToBase64(blob: Blob): Observable<any> {
        const fileReader = new FileReader;
        const observable = new Observable(observer => {
            fileReader.onload = () => {
                const base64Result = <string>fileReader.result;
                observer.next(base64Result);
                observer.complete();
            };

        });
        fileReader.readAsDataURL(blob);
        return observable;
    }

    public saveData(
        blob: any,
        fileName: string = `download_${new Date().toISOString()}`,
        fileFormat: 'xlsx' | 'pdf' | 'xls' | 'png' | 'jpg' | 'doc' | 'docx' | 'csv' = 'pdf'
    ): void {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob);
            return;
        }
        const data = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `${fileName}.${fileFormat}`;
        link.click();
        setTimeout(function () {
            window.URL.revokeObjectURL(data);
        }, 200);
    }
}
